import React from "react";

const palette = {
  border: "#86B6F6",
  ink: "#0B2230",
  accent: "#176B87",
};

const boxShadow = "0 14px 30px rgba(23,107,135,0.14), 0 2px 10px rgba(0,0,0,0.04)";

type FancyItem = { rank: number; name: string; value: number | string };

interface FancyTopListProps {
  title: string;
  items: FancyItem[];
  unit?: string;
}

const medal = (r: number) =>
  r === 1 ? "🥇" : r === 2 ? "🥈" : r === 3 ? "🥉" : "•";

const FancyTopList: React.FC<FancyTopListProps> = ({ title, items, unit }) => {
  const numeric = items.map((i) =>
    typeof i.value === "number" ? i.value : Number(i.value)
  );
  const max = numeric.length ? Math.max(...numeric) : 0;

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #FFFFFF 0%, rgba(238,245,255,0.65) 100%)",
        border: `1px solid ${palette.border}`,
        borderRadius: 14,
        padding: 14,
        boxShadow,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <div style={{ fontWeight: 950, fontSize: 16, color: palette.ink }}>{title}</div>
        <div style={{ fontSize: 12, opacity: 0.7 }}>{unit ?? ""}</div>
      </div>

      <ol style={{ listStyle: "none", padding: 0, margin: "12px 0 0 0" }}>
        {items.map((it) => {
          const v = typeof it.value === "number" ? it.value : Number(it.value);
          const pct = max > 0 ? Math.max(0.1, (v / max) * 100) : 0;

          return (
            <li
              key={`${it.rank}-${it.name}`}
              style={{
                display: "grid",
                gridTemplateColumns: "32px 1fr auto",
                gap: 10,
                alignItems: "center",
                padding: "8px 6px",
                borderRadius: 12,
                border: `1px solid rgba(134,182,246,0.55)`,
                background: "#FFFFFF",
                marginBottom: 8,
              }}
            >
              <div style={{ fontSize: 18, width: 28, textAlign: "center" }}>
                {medal(it.rank)}
              </div>

              <div style={{ display: "grid", gap: 6 }}>
                <div style={{ fontWeight: 800, color: palette.ink }}>{it.name}</div>
                <div
                  style={{
                    height: 6,
                    borderRadius: 999,
                    background: "rgba(180,212,255,0.55)",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${pct}%`,
                      height: "100%",
                      background: `linear-gradient(90deg, ${palette.accent} 0%, rgba(134,182,246,0.95) 100%)`,
                    }}
                  />
                </div>
              </div>

              <div style={{ fontWeight: 950, color: palette.ink }}>
                {it.value}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default FancyTopList;
